import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import ThemeContext from '../../context/theme/themeContext';
import AuthContext from '../../context/auth/authContext';
import NotificationBell from './NotificationBell';
import './Header.css';

// Slim mobile header: brand logo + notifications. Primary navigation lives in
// the bottom nav; the long-tail menu is the "More" bottom sheet.
const Header = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const { isAuthenticated } = useContext(AuthContext);

  return (
    <header className="header mobile-only">
      <Link to={isAuthenticated ? '/dashboard' : '/'} className="header-title">
        <img
          src={isDarkMode ? '/Logo-with-slogan-darkmode.png' : '/Logo-with-slogan.png'}
          alt="PokéMatch"
          className="header-logo"
        />
      </Link>
      {isAuthenticated && (
        <div className="header-actions">
          <NotificationBell />
        </div>
      )}
    </header>
  );
};

export default React.memo(Header);
